"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDA = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("./constants");
class PDA {
    constructor(programId) {
        this.distributor = (mint, version = new anchor_1.BN(1)) => {
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("MerkleDistributor"), mint.toBytes(), version.toArrayLike(Buffer, "le", 8)], constants_1.PROGRAM_ID);
            return {
                key: pda,
                bump,
            };
        };
        this.claim_status = (claimant, distributor) => {
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([
                anchor_1.utils.bytes.utf8.encode("ClaimStatus"),
                claimant.toBytes(),
                distributor.toBytes(),
            ], constants_1.PROGRAM_ID);
            return {
                key: pda,
                bump,
            };
        };
        this.programId = programId;
    }
}
exports.PDA = PDA;
